export default "__VITE_ASSET__BMJQ4vR6__"